export default "__VITE_ASSET__9dbe545d__"